import { Modal } from 'react-responsive-modal';
import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Webcam from "react-webcam";
import { doPost } from './AjaxRequests'
import 'react-responsive-modal/styles.css';
import Swal from 'sweetalert2';

const videoConstraints = {
    minScreenshotHeight: 4096,
    minScreenshotWidth: 2160,
    width: 4096,
    height: 2160,
    facingMode: "environment"
};

function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

const UploadTestKitImage = ({ open, onCloseModal, login, classes, setLogin, camPermission, setCamPermission }) => {

    const onUploadImageChange = (e) => {
        // console.log(formatBytes(e.target.files[0].size));
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onloadend = function () {
            var base64data = reader.result;
            if (base64data.includes('jpeg') || base64data.includes('png') || base64data.includes('jpg')) {
                // console.log(formatBytes(new Blob([base64data]).size));
                setLogin('imgSrc', base64data)
            } else {
                Swal.fire("僅接受jpeg, png, jpg格式檔案", "", "error")
            }

        }
    }


    return <Modal open={open} onClose={onCloseModal} center>
        <h2>上傳家用快篩照片</h2>
        <Grid container spacing={3}  >
            {login.imgSrc ? <>
                <img alt="img" src={login.imgSrc} style={{ margin: "auto" }} width={"100%"} />
                {/* <p>檔案大小: {formatBytes(new Blob([login.imgSrc]).size)}</p> */}
            </> :
                <Webcam
                    audio={false}
                    // height={360}
                    screenshotFormat="image/jpeg"
                    width={"100%"}
                    videoConstraints={videoConstraints}
                    onUserMediaError={() => {
                        // alert('無相機權限')
                        setCamPermission(false)
                    }}
                    style={{ margin: "auto" }}
                >

                    {({ getScreenshot }) => (
                        <Grid item xs={12}>
                            <div className={classes.btn__wrapper}>
                                {camPermission && <Button variant="contained" className={classes.button} size='large' color="secondary"
                                    style={{ margin: '5px', marginTop: "10px" }}
                                    onClick={() => {
                                        const imageSrc = getScreenshot()
                                        setLogin('imgSrc', imageSrc)

                                    }}
                                >
                                    拍照
                                </Button>}

                                <input
                                    type="file"
                                    id="upload-img"
                                    name="img"
                                    accept=".jpeg, .png, .jpg"
                                    style={{ display: "none" }}
                                    onChange={onUploadImageChange}
                                />
                                <label htmlFor="upload-img" className={classes.button} style={{ margin: '5px', marginTop: "10px" }}>
                                    <Button variant="contained" color="primary" component="span" style={{ width: "100%", height: "100%" }}>
                                        上傳照片
                                    </Button>
                                </label>

                                {/* <Button variant="contained" className={classes.button} size='large' color="primary"
                                        style={{margin: '5px', marginTop: "10px" }}
                                        onClick={() => {
                                           

                                        }}
                                    >
                                        上傳照片
                                    </Button> */}
                            </div>
                        </Grid>

                    )}


                </Webcam>
            }
            <Grid item xs={12}>
                {login.imgSrc && <div className={classes.btn__wrapper}>
                    <Button variant="contained" style={{ margin: '5px' }} className={classes.button} size='large' color="secondary" onClick={() => { setLogin("imgSrc", "") }}>
                        重拍/重新上傳
                    </Button>
                    <Button variant="contained" style={{ margin: '5px' }} className={classes.button} size='large' color="primary" onClick={async () => {
                        const tokenData = await doPost(`https://www.kfsyscc.org/normal_api/service`,
                            {
                                "api": "ToccToken"
                            })

                        var base64result = login.imgSrc.replace("data:image/jpeg;base64,", "").replace("data:image/jpg;base64,", "").replace("data:image/png;base64,", "");
                        // alert(base64result)

                        // console.log(tokenData);

                        const data = await doPost(`https://www.kfsyscc.org/normal_api/service`,
                            {
                                "api": "UploadRapidTest",
                                "patid": login.idno,
                                "patname": login.name,
                                "token": tokenData.data,
                                "mime": "image/jpeg",
                                "data": base64result
                            }
                        )
                        if (data.status) {
                            Swal.fire("上傳成功", "", "success")
                            setLogin('imgSrc', '')
                            onCloseModal()
                        } else {
                            Swal.fire(data.message, "", "error")
                        }


                    }}>
                        送出
                    </Button>
                </div>}
            </Grid>
        </Grid>

        {/* 上傳照片 */}

    </Modal>
}

export default UploadTestKitImage